export default "__VITE_ASSET__d1226963__"